<div class="wrapper">
  <div class="logo-wrapper">
    <lib-logo size="medium" variant="normal"></lib-logo>
  </div>

  <div class="card" *ngIf="(step$ | async) === 'password'">
    <div class="header">
      <p class="title">Welcome to Pivot!</p>
      <p class="subtitle">Please set your password to login to your Pivot account.</p>
    </div>
    <div class="form">
      <form class="form-list" [formGroup]="passwordForm" (ngSubmit)="onNextPassword()">
        <div class="form-input">
          <lib-input id="new-password" label="New Password" [type]="inputType.password"
            placeholder="Input your new password" [iconRight]="passwordEyeTemplate" [hint]="
              fieldFocus.password
                ? 'Password must be at least 8 characters, contain at least 1 uppercase letter, 1 symbol, and 1 number'
                : ''
            " [error]="passwordErrMessage" [required]="true" formControlName="password"
            (onIconRightClick)="togglePasswordVisibility()" (onFocus)="onFieldFocus('password', true)"
            (onBlur)="onFieldFocus('password', false)">
          </lib-input>
        </div>
        <div class="form-input">
          <lib-input id="re-enter-password" label="Confirm New Password" [type]="inputType.reEnterPassword"
            placeholder="Confirm your new password" [iconRight]="confirmPasswordEyeTemplate" [hint]="
              fieldFocus.confirmPassword
                ? 'Password must be at least 8 characters, contain at least 1 uppercase letter, 1 symbol, and 1 number'
                : ''
            " [error]="confirmPasswordErrMessage" [required]="true" formControlName="reEnterPassword"
            (onIconRightClick)="toggleConfirmPasswordVisibility()" (onFocus)="onFieldFocus('confirmPassword', true)"
            (onBlur)="onFieldFocus('confirmPassword', false)">
          </lib-input>
        </div>

        <lib-button [attr.type]="'submit'" type="Primary" width="200px" [disabled]="!passwordForm.valid">
          Next
        </lib-button>
      </form>
    </div>
  </div>

  <div class="card tnc-card" *ngIf="(step$ | async) === 'tnc'">
    <div class="header">
      <p class="title">Terms of Service Agreement</p>
      <p class="subtitle">Please review the updated agreement below to proceed with your transaction.</p>
    </div>

    <div class="tnc-body">
      <div class="tnc-document">
        <div class="tnc-document-header">
          <div class="tnc-document-meta">
            <div class="tnc-meta-row">
              <span class="tnc-meta-label">Merchant Partner</span>
              <div class="tnc-meta-id">
                <span class="tnc-meta-id-label">Document ID:</span>
                <span class="tnc-meta-id-value">{{ tncTitle }}</span>
              </div>
            </div>
            <div class="tnc-meta-company">
              <span class="tnc-company-name"> {{ merchantName }} </span>
              <span class="tnc-meta-separator">&bull;</span>
              <span class="tnc-company-role">{{ username }}</span>
            </div>
          </div>
        </div>
        <div class="tnc-document-content" (scroll)="onTncScroll($event)">
          <div class="tnc-content" [innerHTML]="tncHtml"></div>
        </div>
        <div class="tnc-scroll-hint" *ngIf="!isScrolledToBottom">
          <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.66675 4.66669L8.00008 8.00002L11.3334 4.66669M4.66675 8.66669L8.00008 12L11.3334 8.66669"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg> Scroll to end to enable agreement</span>
        </div>
      </div>


      <div class="tnc-checkbox-wrapper">
        <div class="tnc-checkbox-row">
          <div class="tnc-checkbox">
            <input type="checkbox" class="tnc-checkbox-input" [disabled]="!isScrolledToBottom" [checked]="isTncAgreed"
              (change)="onTncCheckboxChange($event)" id="tnc-agree" />
            <label for="tnc-agree" class="tnc-checkbox-label" [class.disabled]="!isScrolledToBottom">
              I confirm I am authorized to sign on behalf of
              <strong> {{ merchantName }} </strong> and agree to Pivot's Terms &amp; Conditions.
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="tnc-actions">
      <lib-button type="Secondary" label="Cancel" width="120px" (click)="onCancelTnc()">
      </lib-button>
      <lib-button type="Primary" label="I Agree & Continue" width="200px" [disabled]="!isTncAgreed"
        (click)="onAgreeTnc()">
      </lib-button>
    </div>
  </div>

  <app-otp *ngIf="(step$ | async) === 'otp' && !isActivating"
    [displayOtpDialog]="(step$ | async) === 'otp' && !isActivating" [event]="'first-time-login'"
    (isOtpComplete)="onOtpComplete($event)" mode="dialog"></app-otp>

  <div class="card activating-card" *ngIf="isActivating">
    <div class="activating-content">
      <div class="spinner icon progress-spinner"></div>
      <h2 class="title">Activating your account…</h2>
      <p class="subtitle">Please wait a moment while we set things up for you.</p>
    </div>
  </div>

  <ng-container *ngIf="(step$ | async) === 'greeting'">
    <div class="card greeting-wrapper">
      <div class="icon-container">
        <img src="assets/icon/blue-check-animated.svg" alt="Success Icon" class="success-icon" />
      </div>
      <h2 class="title">Welcome {{ username }}!</h2>
      <p class="subtitle">
        Congratulations!🎉 Your account is now active. <br />
        You're all set to explore Pivot.
      </p>

      <div class="explore-btn">
        <lib-button (click)="onExplore()" label="Explore Now" size="Large" type="Primary" width="130px">
        </lib-button>
      </div>
    </div>
  </ng-container>
</div>

<!-- Eye icon templates -->
<ng-template #passwordEyeTemplate>
  <lib-icons [name]="passwordEyeIconName" category="system"></lib-icons>
</ng-template>

<ng-template #confirmPasswordEyeTemplate>
  <lib-icons [name]="confirmPasswordEyeIconName" category="system"></lib-icons>
</ng-template>